module.exports = __webpack_public_path__ + "img/email-2-icon.b2fecd17.png";